import {isNil, sort} from 'ramda';

import i18n from '@dms/i18n';

export type IsKnownPresetFeature = (featureKey: string) => boolean;

const MAX_FEATURE_TAGS = 4;
const VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE = 3;

/** Feature labels for the preset summary, capped. Keys missing from the catalogue are dropped. */
export function getFeaturesPresetTags(
  features: string[] | null,
  getFeatureLabel: (featureKey: string) => string,
  isKnownFeature: IsKnownPresetFeature
): string[] {
  if (isNil(features) || features.length === 0) {
    return [];
  }

  const knownFeatures = features.filter(isKnownFeature);

  if (knownFeatures.length === 0) {
    return [];
  }

  const labels = sort(
    (left, right) => getFeatureLabel(left).localeCompare(getFeatureLabel(right)),
    knownFeatures
  ).map(getFeatureLabel);

  if (labels.length <= MAX_FEATURE_TAGS) {
    return labels;
  }

  return [
    ...labels.slice(0, VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE),
    i18n.t('entity.sourcing.labels.nMore', {
      count: labels.length - VISIBLE_FEATURE_LABELS_BEFORE_AND_MORE,
    }),
  ];
}
